// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"228":"8a0bd705","738":"4fbedf4a"}[chunkId] + ".chunk.css";
};